import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS = defineFcm('revenue_subs_one_time_contributions')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Membership landing page',
		description: 'This FC is to make one time contributions available on the membership landing page',
	});
